import PropTypes from 'prop-types';
import { arePropsMissing } from '../../../utils/helpers';
import { Grid } from '../../../utils/grid/Grid';
import Toggle from '../../../utils/Toggle';
import HeroImage from '../../../components/heroImage/HeroImage';
import Section from '../../../utils/section/Section';
import IconTextList from '../../../components/iconText/IconTextList';
import LandingpageTeaserList from '../../../components/landingpageTeaser/LandingpageTeaserList';
import HostTeaserSmallList from '../../../components/hostTeaser/HostTeaserSmallList';
import HostTeaserBigList from '../../../components/hostTeaser/HostTeaserBigList';
import SearchWidgetContainer from '../../../components/search/components/SearchWidgetContainer';
import SearchWidgetBigContainer from '../../../components/search/containers/SearchWidgetBigContainer';
import Meta from '../../../utils/meta/Meta';
import GtmLastMinuteSection from '../../../features/gtmLastMinuteIntegration/GtmLastMinuteSection';

import './home.css';

const Home = (props) => {
  if (
    arePropsMissing([
      props.searchFilter,
      props.heroImage,
      props.iconTeaser,
      props.sectionTitle,
      props.landingpageTeaser,
      props.lastProperties,
      props.hostTeaser,
    ])
  ) {
    return null;
  }

  return (
    <div>
      <Meta />
      <div className="header-media">
        <Grid>
          <SearchWidgetContainer
            headline={props.sectionTitle.searchTitle}
            subline={props.sectionTitle.searchSubtitle}
            inverseText={props.heroImage.slug === 'wellnesssuites'}
          >
            <SearchWidgetBigContainer options={props.searchFilter} withButton />
          </SearchWidgetContainer>
        </Grid>
        <Toggle hide="xs sm">
          <HeroImage tall {...props.heroImage} />
        </Toggle>
      </div>
      <Toggle hide="xs sm">
        <Section border highlight>
          <IconTextList teaser={props.iconTeaser} />
        </Section>
      </Toggle>
      <Section headline={props.sectionTitle.landingpageTeaser}>
        <LandingpageTeaserList teaser={props.landingpageTeaser} />
      </Section>
      {props.lastProperties && props.lastProperties.length ? (
        <Section headline={props.sectionTitle.lastProperties} className="home-last-properties">
          <HostTeaserSmallList hosts={props.lastProperties} showPrices={false} />
        </Section>
      ) : null}
      <GtmLastMinuteSection />
      <Section headline={props.sectionTitle.hostTeaser}>
        <HostTeaserBigList hosts={props.hostTeaser} showPrices={false} />
      </Section>
    </div>
  );
};

Home.propTypes = {
  searchFilter: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  heroImage: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  iconTeaser: PropTypes.arrayOf(PropTypes.object),
  sectionTitle: PropTypes.shape({
    searchTitle: PropTypes.string.isRequired,
    searchSubtitle: PropTypes.string.isRequired,
    landingpageTeaser: PropTypes.string.isRequired,
    lastProperties: PropTypes.string.isRequired,
    hostTeaser: PropTypes.string.isRequired,
  }),
  landingpageTeaser: PropTypes.arrayOf(PropTypes.object),
  lastProperties: PropTypes.arrayOf(PropTypes.object),
  hostTeaser: PropTypes.arrayOf(PropTypes.object),
};

export default Home;
